// extracted by mini-css-extract-plugin
module.exports = {"dropdown-menu":"styles-module__dropdown-menu___3P1-u"};